var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "confirm-line-haul-connection"
  }, [_c('div', {
    staticClass: "animated fadeInDown"
  }, [_c('fieldset', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body1"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingUpload
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingUpload = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-body1 col-md-12",
    staticStyle: {
      "margin-bottom": "0rem",
      "padding": "0px",
      "background-color": "white"
    }
  }, _vm._l((_vm.tabs), function(tab) {
    return _c('button', {
      key: tab.key,
      class: ['tab-button', {
        active: _vm.currentTab === tab.key
      }],
      style: (("" + ((_vm.tabs.length==1) ? 'width: 100%;' : ''))),
      attrs: {
        "id": tab.value
      },
      on: {
        "click": function($event) {
          _vm.currentTab = tab.key;
          _vm.secondFunction(tab);
        }
      }
    }, [_vm._v("\n            " + _vm._s(tab.value) + "\n          ")])
  }), 0), _vm._v(" "), _c('fieldset', [(_vm.currentTab == 'upload') ? _c('b-card', [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onUploadSubmit.apply(null, arguments)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v(" NTC Mapping File ")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-file'></i>"
    }
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    class: {
      'form-control': true, 'error': _vm.errors.has('configFile')
    },
    attrs: {
      "type": "file",
      "placeholder": "Upload File",
      "name": "configFile",
      "id": "configFile",
      "accept": ".csv"
    }
  })]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("Note: * Only .csv files allowed to upload. Max size 5 MB.")])], 1), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('configFile')),
      expression: "errors.has('configFile')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Upload file is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Download Sample File")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download empty NTC Mapping sample .csv"
    },
    on: {
      "click": _vm.downloadSampleCsv
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("Sample\n                          "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "#20a8d8"
    }
  })])])])], 1), _vm._v(" "), (_vm.failed.length > 0) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Download Failed Rows")]), _vm._v(" "), _c('b-input-group', {
    staticStyle: {
      "height": "45px"
    },
    attrs: {
      "left": "<i class='fa fa-file-text'></i>"
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "Download failed NTC Mapping rows"
    },
    on: {
      "click": _vm.exportFailedConfig
    }
  }, [_c('span', {
    staticClass: "form-control",
    staticStyle: {
      "border": "0"
    }
  }, [_vm._v("Download\n                          "), _c('i', {
    staticClass: "fa fa-download",
    staticStyle: {
      "margin-left": "10px",
      "font-size": "18px",
      "color": "red"
    }
  })])])])], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "expected-column"
  }, [_c('div', {
    staticClass: "expected-title"
  }, [_vm._v("Expected columns:")]), _vm._v(" "), _c('div', {
    staticClass: "column-tags"
  }, _vm._l((_vm.ntcColumns), function(col) {
    return _c('span', {
      key: col.key,
      class: ['column-tag', col.required ? 'mandatory' : 'optional'],
      attrs: {
        "title": col.required ? 'Required column' : 'Optional column'
      }
    }, [_vm._v("\n                          " + _vm._s(col.header) + "\n                          "), (!col.required) ? _c('em', {
      staticClass: "optional-hint"
    }, [_vm._v("(optional)")]) : _vm._e()])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "layout-note"
  }, [_vm._v("\n                        Column headers in the uploaded file must match exactly (case-sensitive).\n                        Recommended order: Scan location → Bag Origin → Bag destination Id →\n                        Bag destination → "), _c('strong', [_vm._v("Route")]), _vm._v(" (Air or Surface) → NTC → Secondary NTC.\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "layout-note"
  }, [_c('strong', [_vm._v("Note:")]), _vm._v(" Leaving "), _c('strong', [_vm._v("Secondary NTC")]), _vm._v(" blank in the CSV\n                        will clear any existing Secondary NTC for that route. Re-uploading the same\n                        route with a different Primary NTC updates the existing row in place — no\n                        conflict error is raised.\n                      ")])])])]), _vm._v(" "), (_vm.lastUploadSummary) ? _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "upload-summary"
  }, [_c('div', {
    staticClass: "upload-summary-title"
  }, [_vm._v("Last upload summary")]), _vm._v(" "), _c('div', {
    staticClass: "upload-summary-body"
  }, [(_vm.lastUploadSummary.totalRows != null) ? _c('span', {
    staticClass: "upload-summary-chip total"
  }, [_vm._v("\n                          Total rows: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.totalRows))])]) : _vm._e(), _vm._v(" "), (_vm.lastUploadSummary.validCount != null) ? _c('span', {
    staticClass: "upload-summary-chip valid"
  }, [_vm._v("\n                          Valid: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.validCount))])]) : _vm._e(), _vm._v(" "), (_vm.lastUploadSummary.insertedCount != null) ? _c('span', {
    staticClass: "upload-summary-chip inserted"
  }, [_vm._v("\n                          New inserted: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.insertedCount))])]) : _vm._e(), _vm._v(" "), (_vm.lastUploadSummary.updatedCount != null) ? _c('span', {
    staticClass: "upload-summary-chip updated"
  }, [_vm._v("\n                          Existing updated: "), _c('strong', [_vm._v(_vm._s(_vm.lastUploadSummary.updatedCount))])]) : _vm._e()])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "submit",
      "title": "Upload NTC Mapping file"
    }
  }, [_c('i', {
    staticClass: "fa fa-upload"
  }), _vm._v(" Upload\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetForm
    }
  }, [_vm._v("Reset")])])])]) : (_vm.currentTab == 'Manage') ? _c('b-card', [(_vm.hublist.length) ? [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isAddingRow
    },
    on: {
      "update:active": function($event) {
        _vm.isAddingRow = $event
      }
    }
  }), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.addMappingRow.apply(null, arguments)
      }
    }
  }, [_c('fieldset', [_c('div', {
    staticClass: "form-group row ntc-add-form-row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6"
  }, [_c('label', [_vm._v("Bag Origin")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('bagOrigin')
    },
    attrs: {
      "options": _vm.bagOriginOptions,
      "selected-option": _vm.hubItems.bagOrigin,
      "name": "bagOrigin",
      "placeholder": "Select Bag Origin"
    },
    on: {
      "select": function($event) {
        return _vm.selectHub('bagOrigin', $event)
      }
    },
    model: {
      value: (_vm.hubValues.bagOrigin),
      callback: function($$v) {
        _vm.$set(_vm.hubValues, "bagOrigin", $$v)
      },
      expression: "hubValues.bagOrigin"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bagOrigin')),
      expression: "errors.has('bagOrigin')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Bag Origin is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6"
  }, [_c('label', [_vm._v("Scan Location")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('scanLocation')
    },
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.hubItems.scanLocation,
      "name": "scanLocation",
      "placeholder": "Select Scan Location"
    },
    on: {
      "select": function($event) {
        return _vm.selectHub('scanLocation', $event)
      }
    },
    model: {
      value: (_vm.hubValues.scanLocation),
      callback: function($$v) {
        _vm.$set(_vm.hubValues, "scanLocation", $$v)
      },
      expression: "hubValues.scanLocation"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('scanLocation')),
      expression: "errors.has('scanLocation')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Scan Location is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6"
  }, [_c('label', [_vm._v("Destination")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('destination')
    },
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.hubItems.destination,
      "name": "destination",
      "placeholder": "Select Destination"
    },
    on: {
      "select": function($event) {
        return _vm.selectHub('destination', $event)
      }
    },
    model: {
      value: (_vm.hubValues.destination),
      callback: function($$v) {
        _vm.$set(_vm.hubValues, "destination", $$v)
      },
      expression: "hubValues.destination"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destination')),
      expression: "errors.has('destination')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Destination is required.")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row ntc-add-form-row"
  }, [_c('div', {
    staticClass: "col-md-4 col-sm-6"
  }, [_c('label', [_vm._v("Route")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-plane'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('route')
    },
    attrs: {
      "options": _vm.routeModeOptions,
      "selected-option": _vm.hubItems.route,
      "name": "route",
      "placeholder": "Air / Surface"
    },
    on: {
      "select": function($event) {
        return _vm.selectRouteMode('route', $event)
      }
    },
    model: {
      value: (_vm.hubValues.route),
      callback: function($$v) {
        _vm.$set(_vm.hubValues, "route", $$v)
      },
      expression: "hubValues.route"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('route')),
      expression: "errors.has('route')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("Route is required (Air or Surface).")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-6"
  }, [_c('label', [_vm._v("NTC")]), _c('span', {
    staticClass: "text-danger"
  }, [_vm._v(" *")]), _vm._v(" "), _c('b-input-group', {
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('basic-select', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required:true}"
    }],
    staticClass: "form-control",
    class: {
      'form-control': true, 'error': _vm.errors.has('ntc')
    },
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.hubItems.ntc,
      "name": "ntc",
      "placeholder": "Select NTC"
    },
    on: {
      "select": function($event) {
        return _vm.selectHub('ntc', $event)
      }
    },
    model: {
      value: (_vm.hubValues.ntc),
      callback: function($$v) {
        _vm.$set(_vm.hubValues, "ntc", $$v)
      },
      expression: "hubValues.ntc"
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('ntc')),
      expression: "errors.has('ntc')"
    }],
    staticClass: "text-danger"
  }, [_vm._v("NTC is required.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 col-sm-12"
  }, [_c('label', [_vm._v("Secondary NTC")]), _vm._v(" "), _c('span', {
    staticClass: "text-muted",
    staticStyle: {
      "margin-left": "6px",
      "font-size": "11px"
    },
    attrs: {
      "title": "Optional. Backup NTC hub for this route."
    }
  }, [_vm._v("\n                      (optional)\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "secondary-ntc-picker"
  }, [_c('b-input-group', {
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "left": "<i class='fa fa-university'></i>"
    }
  }, [_c('basic-select', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.hubItems.secondaryNtc,
      "name": "secondaryNtc",
      "placeholder": "Select Secondary NTC (optional)"
    },
    on: {
      "select": function($event) {
        return _vm.selectHub('secondaryNtc', $event)
      }
    },
    model: {
      value: (_vm.hubValues.secondaryNtc),
      callback: function($$v) {
        _vm.$set(_vm.hubValues, "secondaryNtc", $$v)
      },
      expression: "hubValues.secondaryNtc"
    }
  })], 1), _vm._v(" "), (_vm.hubValues.secondaryNtc) ? _c('button', {
    staticClass: "btn btn-link btn-sm secondary-ntc-clear",
    attrs: {
      "type": "button",
      "title": "Clear Secondary NTC"
    },
    on: {
      "click": _vm.clearAddSecondaryNtc
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Clear\n                      ")]) : _vm._e()], 1), _vm._v(" "), _c('small', {
    staticClass: "text-muted d-block"
  }, [_vm._v("\n                      Backup NTC hub for this route. Must be different from Primary NTC.\n                    ")])])]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "0.8em"
    }
  }, [_vm._v(_vm._s(_vm.hubloader))])]), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_c('button', {
    staticClass: "common-success btn btn-secondary",
    attrs: {
      "type": "submit",
      "title": "Add or update the NTC mapping. Re-submitting an existing route with the same Primary NTC and no new Secondary NTC will be rejected."
    }
  }, [_c('i', {
    staticClass: "fa fa-plus"
  }), _vm._v(" Add\n                ")]), _vm._v(" "), _c('button', {
    staticClass: "common-danger btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetAddForm
    }
  }, [_vm._v("Reset")])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "position": "relative",
      "margin-top": "15px"
    }
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSearching
    },
    on: {
      "update:active": function($event) {
        _vm.isSearching = $event
      }
    }
  }), _vm._v(" "), _c('h6', {
    staticClass: "text-primary"
  }, [_vm._v("Search NTC Mappings")]), _vm._v(" "), (_vm.manageSearchReady) ? [_c('div', {
    staticClass: "ntc-search-block",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "form-group row ntc-search-filters"
  }, [_c('div', {
    staticClass: "col-xl-2 col-lg-4 col-md-4 col-sm-6 ntc-search-field"
  }, [_c('label', [_vm._v("Bag Origin")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.bagOriginOptions,
      "selected-option": _vm.searchItems.bagOrigin,
      "placeholder": "Select Bag Origin"
    },
    on: {
      "select": function($event) {
        return _vm.selectSearchFilter('bagOrigin', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-lg-4 col-md-4 col-sm-6 ntc-search-field"
  }, [_c('label', [_vm._v("Scan Location")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.searchItems.scanLocation,
      "placeholder": "Select Scan Location"
    },
    on: {
      "select": function($event) {
        return _vm.selectSearchFilter('scanLocation', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-lg-4 col-md-4 col-sm-6 ntc-search-field"
  }, [_c('label', [_vm._v("Destination")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.searchItems.destination,
      "placeholder": "Select Destination"
    },
    on: {
      "select": function($event) {
        return _vm.selectSearchFilter('destination', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-lg-4 col-md-4 col-sm-6 ntc-search-field"
  }, [_c('label', [_vm._v("Route")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.routeModeOptions,
      "selected-option": _vm.searchItems.routeMode,
      "placeholder": "Air / Surface"
    },
    on: {
      "select": function($event) {
        return _vm.selectSearchFilter('routeMode', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xl-2 col-lg-4 col-md-4 col-sm-6 ntc-search-field"
  }, [_c('label', [_vm._v("NTC")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.searchItems.ntc,
      "placeholder": "Select NTC"
    },
    on: {
      "select": function($event) {
        return _vm.selectSearchFilter('ntc', $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row ntc-search-actions-row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.applyFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.resetFilters
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh"
  }), _vm._v(" Reset\n                    ")])])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "table-responsive ntc-mapping-table-wrap",
    style: (_vm.mappings.length > 8 ? 'max-height: 395px; overflow: auto;' : '')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables ntc-mapping-table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Bag Origin")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Scan Location")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Destination")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Route")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("NTC")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Secondary NTC")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Is Active")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.mappings), function(row, index) {
    return _c('tr', {
      key: row.id || index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((_vm.pageno * _vm.limit) + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.bagOriginHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.scanLocationHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.destinationHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.routeMode))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.ntcHubName))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [(row.secondaryNtcHubName) ? _c('span', [_vm._v(_vm._s(row.secondaryNtcHubName))]) : _c('span', {
      staticClass: "text-muted",
      attrs: {
        "title": "No Secondary NTC set"
      }
    }, [_vm._v("—")])]), _vm._v(" "), _c('td', {
      staticClass: "text-center",
      style: ({
        color: row.isActive ? 'green' : 'red'
      })
    }, [_vm._v("\n                        " + _vm._s((row.is_active !== undefined ? row.is_active : row.isActive) ? 'Active' : 'Inactive') + "\n                      ")]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-primary",
      attrs: {
        "title": "Edit NTC / Secondary NTC / Destination / Toggle Active"
      },
      on: {
        "click": function($event) {
          return _vm.openEditRow(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    })])])])
  }), _vm._v(" "), (_vm.mappings.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "10"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.totalRows > _vm.limit),
      expression: "totalRows > limit"
    }],
    attrs: {
      "page-count": _vm.pageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getPaginationData,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 2)] : _c('span', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.hubloader || 'Loading hubs...'))])], 2) : (_vm.currentTab == 'history') ? _c('b-card', [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isLoadingAudit
    },
    on: {
      "update:active": function($event) {
        _vm.isLoadingAudit = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    style: (_vm.auditRows.length > 8 ? 'overflow: auto; height: 395px;' : 'overflow: auto;')
  }, [_c('table', {
    staticClass: "table-bordered table-hover tbl datatables",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', {
    staticClass: "text-primary"
  }, [_c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Action")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Modified By")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Modified Date")]), _vm._v(" "), _c('th', {
    staticClass: "text-center tableheader"
  }, [_vm._v("Remarks")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.auditRows), function(row, index) {
    return _c('tr', {
      key: row.id || index
    }, [_c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s((_vm.auditPageno * _vm.auditLimit) + index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_c('span', {
      class: _vm.auditActionBadgeClass(row.action)
    }, [_vm._v(_vm._s(row.action))])]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(row.modifiedBy))]), _vm._v(" "), _c('td', {
      staticClass: "text-center"
    }, [_vm._v(_vm._s(_vm._f("moment")(row.modifiedDate)))]), _vm._v(" "), _c('td', {
      staticClass: "text-left"
    }, [_vm._v(_vm._s(row.remarks))])])
  }), _vm._v(" "), (_vm.auditRows.length < 1) ? _c('tr', [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("No Data Found")])]) : _vm._e()], 2)])]), _vm._v(" "), _c('paginate', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.auditTotalRows > _vm.auditLimit),
      expression: "auditTotalRows > auditLimit"
    }],
    attrs: {
      "page-count": _vm.auditPageCount,
      "page-range": 2,
      "margin-pages": 2,
      "click-handler": _vm.getAuditPagination,
      "prev-text": '<<',
      "next-text": '>>',
      "container-class": 'pagination'
    }
  })], 1) : _vm._e()], 1)], 1)])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "id": "editNtcMappingModal",
      "title": "Edit NTC Mapping",
      "hide-footer": "",
      "hide-header": ""
    },
    model: {
      value: (_vm.isEditModalShow),
      callback: function($$v) {
        _vm.isEditModalShow = $$v
      },
      expression: "isEditModalShow"
    }
  }, [_c('div', {
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-headerfrm"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Edit NTC Mapping")]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.closeEditModal
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bodyfrm"
  }, [_c('vue-element-loading', {
    attrs: {
      "spinner": "line-scale",
      "color": "#FF6700",
      "active": _vm.isSavingEdit
    },
    on: {
      "update:active": function($event) {
        _vm.isSavingEdit = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Bag Origin")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.bagOrigin
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('label', [_vm._v("Scan Location")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": _vm.editForm.scanLocation
    }
  })])]), _vm._v(" "), (_vm.isEditModalShow) ? [_c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Route")]), _vm._v(" "), _c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "title": "Route cannot be changed after the row is created"
    },
    domProps: {
      "value": _vm.editForm.routeMode
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Destination")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.editItems.destination,
      "placeholder": "Select Destination"
    },
    on: {
      "select": function($event) {
        return _vm.selectEditField('destination', $event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("NTC")]), _vm._v(" "), _c('basic-select', {
    staticClass: "form-control",
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.editItems.ntc,
      "placeholder": "Select NTC"
    },
    on: {
      "select": function($event) {
        return _vm.selectEditField('ntc', $event)
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('label', [_vm._v("Secondary NTC")]), _vm._v(" "), _c('span', {
    staticClass: "text-muted",
    staticStyle: {
      "margin-left": "6px",
      "font-size": "11px"
    },
    attrs: {
      "title": "Optional. Backup NTC hub for this route."
    }
  }, [_vm._v("\n                (optional)\n              ")]), _vm._v(" "), _c('div', {
    staticClass: "secondary-ntc-picker"
  }, [_c('basic-select', {
    staticClass: "form-control",
    staticStyle: {
      "flex": "1"
    },
    attrs: {
      "options": _vm.hublist,
      "selected-option": _vm.editItems.secondaryNtc,
      "placeholder": "Select Secondary NTC (optional)"
    },
    on: {
      "select": function($event) {
        return _vm.selectEditField('secondaryNtc', $event)
      }
    }
  }), _vm._v(" "), (_vm.editForm.secondaryNtc) ? _c('button', {
    staticClass: "btn btn-link btn-sm secondary-ntc-clear",
    attrs: {
      "type": "button",
      "title": "Clear Secondary NTC — submitting after clearing will remove it from this route."
    },
    on: {
      "click": _vm.clearEditSecondaryNtc
    }
  }, [_c('i', {
    staticClass: "fa fa-times-circle"
  }), _vm._v(" Clear\n                ")]) : _vm._e()], 1), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("\n                Clear this field to remove the Secondary NTC from this route.\n                Cannot be the same hub as Primary NTC.\n              ")])])])] : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group row",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Is Active")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "8px"
    }
  }, [_c('label', {
    staticClass: "switch",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editForm.isActive),
      expression: "editForm.isActive"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.editForm.isActive) ? _vm._i(_vm.editForm.isActive, null) > -1 : (_vm.editForm.isActive)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.editForm.isActive,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.editForm, "isActive", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.editForm, "isActive", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.editForm, "isActive", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "8px"
    }
  }, [_vm._v(_vm._s(_vm.editForm.isActive ? 'Active' : 'Inactive'))])])])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footerfrm",
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "button",
      "disabled": _vm.isSavingEdit
    },
    on: {
      "click": _vm.submitEdit
    }
  }, [_c('i', {
    staticClass: "fa fa-save"
  }), _vm._v(" Save\n          ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "margin-left": "8px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.closeEditModal
    }
  }, [_vm._v("\n            Cancel\n          ")])])])])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-body1",
    staticStyle: {
      "margin-bottom": "0.5%",
      "background-color": "white"
    }
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('legend', {
    staticStyle: {
      "border": "0px"
    }
  }, [_vm._v("NTC Mapping Master")])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c705cc38","hasScoped":true}!./src/views/components/NtcMappingMaster/NtcMappingMaster.html
// module id = 2075
// module chunks = 2